import { z } from "zod"

export const DynamicDropdownSchema = z.object({
  id: z.number(),
  type: z.number(),
  type_name: z.string(),
  option: z.string(),
})

export const DynamicDropdownFormSchema = z.object({
  type: z.number(),
  option: z.string().min(1, "dynamicDropdowns.validation.optionRequired"),
})

export const DROPDOWN_TYPES = [
  { value: 5, label: "Tipos de Contato" },
  { value: 10, label: "Contactos Alternativos - Departamentos" },
]

export type DynamicDropdown = z.infer<typeof DynamicDropdownSchema>
export type DynamicDropdownFormValues = z.infer<
  typeof DynamicDropdownFormSchema
>
